import { whoAmIQuery } from '@shared/queries/whoAmI.query';
import { useTanstackQuery } from '../../core/hooks/useTanstackQuery';

const useWhoAmI = (enabled: boolean) => {
  const getProfile = useTanstackQuery({
    instance: whoAmIQuery.getWhoAmI$(enabled),
    dependencies: [enabled]
  });

  return { getProfile };
};

export { useWhoAmI };
